import { useTheme } from '@shopify/restyle';
import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';
import type { Theme } from 'app/shopify';

export function ReferralCardTitle({
  isReferralProgram202506,
  numInvited,
  tPrefix,
}: {
  isReferralProgram202506: boolean;
  numInvited: number;
  tPrefix: string;
}) {
  const theme = useTheme<Theme>();
  if (isReferralProgram202506) {
    return (
      <Text fontWeight="600" variant="bodyLarge">
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          i18nKey={`${tPrefix}currentStep.${(numInvited % 5).toFixed()}`}
          ns="invite"
        />
      </Text>
    );
  }
  return (
    <>
      <Text fontWeight="600" variant="bodyLarge" style={{ marginBottom: theme.spacing['spacing.general.x2'] }}>
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          count={numInvited}
          i18nKey={`${tPrefix}referrals.title`}
          ns="invite"
        />
      </Text>
      <Text
        lineHeight={22}
        fontSize={14}
        textAlign="center"
        variant="bodyBase"
        style={{ color: theme.colors['text.secondary'] }}
      >
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          count={numInvited}
          i18nKey={`${tPrefix}referrals.subTitle`}
          ns="invite"
        />
      </Text>
    </>
  );
}
